import { render, staticRenderFns } from "./GuestFeatureAddRequestedModal.vue?vue&type=template&id=6baf1b7a&scoped=true&"
import script from "./GuestFeatureAddRequestedModal.vue?vue&type=script&lang=js&"
export * from "./GuestFeatureAddRequestedModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6baf1b7a",
  null
  
)

export default component.exports